import {State} from '../store';
import {AlbumOptions} from './reducer';

export const getPendingAlbumOptionsOverlay = (state: State): AlbumOptions|undefined => state.albumOptions.options;
